let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ehCbf")).then(() => parcelRequire('6dsY7'));